import React from "react";
import "./CertificateGroupingTVOC.scss";
import CertificateGroupingListTVOCReview from "../../features/CertificateGroupingListTVOCReview/CertificateGroupingListTVOCReview";

const CertificateGroupingTVOCForReview = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingListTVOCReview />
    </div>
  );
};

export default CertificateGroupingTVOCForReview;